module.exports = __webpack_public_path__ + "static/hero-image-mobile-03b3c90f0c653e73db152e36e6ec2750.svg";